__turbopack_context__.v({
  "QuantityChange": "QuantityChange-module__4Syw6W__QuantityChange",
  "button": "QuantityChange-module__4Syw6W__button",
  "icon": "QuantityChange-module__4Syw6W__icon",
  "quantity": "QuantityChange-module__4Syw6W__quantity",
});
